import GoogleMapsMarkerColorEnum from "@models/Google Maps/GoogleMapsMarkerColorEnum";
import GoogleMapsMarkerSizeEnum from "@models/Google Maps/GoogleMapsMarkerSizeEnum";
import INewAddress from "@models/INewAddress";

export const useGoogleMaps = ({markerSize, markerColor, zoomLevel, size}: {markerSize?: GoogleMapsMarkerSizeEnum, markerColor?: GoogleMapsMarkerColorEnum | string, zoomLevel?: number, size?: string}) => {

    const getEncodedAddress = (details: INewAddress): string => {
        const encodedLineOne = encodeURIComponent(details.address_line_one!);
        const encodedCity = encodeURIComponent(details.city!);
        const encodedState = encodeURIComponent(details.state!);

        const address = `${encodedLineOne},${encodedCity},${encodedState}`;
        const encodedAddress = address;

        return encodedAddress;
    };

    const getGoogleMapsAPIKey = (): string => {
        const apiKey = "AIzaSyDexP9SNNhjEZ-mRYaZdxhxm6amPB0Onz0";

        return apiKey;
    };

    const getZoomLevel = (): number => {
        const _zoomLevel = zoomLevel ? zoomLevel : 15;

        return _zoomLevel;
    };

    const getMarkerColor = (): GoogleMapsMarkerColorEnum | string => {
        let _markerColor: GoogleMapsMarkerColorEnum | string = `color:${GoogleMapsMarkerColorEnum.RED}%7C`;

        if (markerColor) {
            if (!(markerColor in GoogleMapsMarkerColorEnum)) {
                _markerColor = `color:0x${markerColor}%7C`;
            }
        }

        return _markerColor;
    };

    const getMarkerSize = (): string => {
        let _markerSize: string = "";

        if (markerSize) {
            _markerSize = `size:${markerSize}%7C`;
        }

        return _markerSize;
    };

    

    const getSize = (): string => {
        const _size = size ? size : "400x200";

        return _size;
    };

    const getImageSize = (): { width: number; height: number } => {
        let width = 400;
        let height = 200;

        if (size) {
            const regex = /(\d+)x(\d+)/;

            const sizeDetail = size.match(regex);

            if (sizeDetail && sizeDetail[0]) {
                width = Number(sizeDetail[0] || 0);
            }

            if (sizeDetail && sizeDetail[1]) {
                height = Number(sizeDetail[1] || 0);
            }
        }

        return { width, height };
    };

    return {
        getEncodedAddress,
        getGoogleMapsAPIKey,
        getZoomLevel,
        getMarkerColor,
        getMarkerSize,
        getSize,
        getImageSize
    }
  
};

